var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 67,
    viewBox: "0 0 90 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3067 6.15163L10.173 33.2667L30.3067 60.3817C30.6393 60.8237 30.8666 61.3177 30.9756 61.8353C31.0845 62.3529 31.073 62.8838 30.9417 63.3976C30.8104 63.9113 30.5618 64.3978 30.2103 64.8289C29.8587 65.26 29.4112 65.6273 28.8935 65.9097C28.3757 66.192 27.7979 66.3838 27.1933 66.4741C26.5887 66.5644 25.9693 66.5513 25.3706 66.4356C24.7719 66.32 24.2059 66.104 23.705 65.8001C23.204 65.4963 22.7782 65.1106 22.4518 64.6651L0.72766 35.4084C0.252421 34.7683 0 34.0253 0 33.2667C0 32.508 0.252421 31.765 0.72766 31.1249L22.4518 1.86817C23.1183 0.982435 24.1666 0.358681 25.3679 0.133124C26.5691 -0.0924323 27.8257 0.0985361 28.8633 0.664325C29.9008 1.23011 30.6349 2.12475 30.9054 3.15287C31.1758 4.18099 30.9606 5.25905 30.3067 6.15163ZM89.2723 31.1249L67.5482 1.86817C67.2218 1.42274 66.796 1.03701 66.295 0.733156C65.7941 0.429304 65.2281 0.213334 64.6294 0.0976699C64.0307 -0.0179943 63.4113 -0.0310693 62.8067 0.059197C62.2021 0.149463 61.6243 0.341289 61.1065 0.623639C60.5888 0.905989 60.1413 1.27329 59.7897 1.70441C59.4382 2.13553 59.1896 2.62197 59.0583 3.13572C58.927 3.64948 58.9155 4.18043 59.0244 4.69801C59.1334 5.2156 59.3607 5.70961 59.6933 6.15163L79.827 33.2667L59.6933 60.3817C59.3607 60.8237 59.1334 61.3177 59.0244 61.8353C58.9155 62.3529 58.927 62.8838 59.0583 63.3976C59.1896 63.9113 59.4382 64.3978 59.7897 64.8289C60.1413 65.26 60.5888 65.6273 61.1065 65.9097C61.6243 66.192 62.2021 66.3838 62.8067 66.4741C63.4113 66.5644 64.0307 66.5513 64.6294 66.4356C65.2281 66.32 65.7941 66.104 66.295 65.8001C66.796 65.4963 67.2218 65.1106 67.5482 64.6651L89.2723 35.4084C89.7476 34.7683 90 34.0253 90 33.2667C90 32.508 89.7476 31.765 89.2723 31.1249Z",
    fill: "#E6E6E6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.6041,
    y: 15.2996,
    width: 32.8103,
    height: 5.32919,
    rx: 2.6646,
    fill: "#00ADB5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2177,
    y: 44.4833,
    width: 32.8103,
    height: 5.32919,
    rx: 2.6646,
    fill: "#FF1C89"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.24,
    y: 23.1666,
    width: 27.1711,
    height: 3.04525,
    rx: 1.52263,
    fill: "#FF1C89"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.9138,
    y: 28.4957,
    width: 55.1111,
    height: 3.80656,
    rx: 1.90328,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0153,
    y: 34.3325,
    width: 23.5824,
    height: 3.04525,
    rx: 1.52263,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 42.009,
    y: 39.6616,
    width: 24.0951,
    height: 3.04525,
    rx: 1.52263,
    fill: "#00ADB5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.82a2c9ce583147dbc1a8818e765b6c36.svg";
export { ForwardRef as ReactComponent };